<template>
  <div id="InjMold-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width: 40%">
          <top-header
            name="topHeader"
            :PageTitle="PageTitle"
            ActiveMenuIndex="InjMold"
          />
        </div>
        <div style="width: 60%">
          <el-select
            v-model="selectedBU"
            style="right: -450px"
            class="block-top-button-field"
            placeholder="所有BU"
            @change="refreshPlantList()"
          >
            <el-option
              v-for="item in BUList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            id="selectedPlant"
            v-model="selectedPlant"
            class="block-top-button-field"
            multiple
            filterable
            clearable
            placeholder="所有工厂"
            style="right: -450px"
            @change="
              changeSelectComponent('工厂', 'selectedPlant');
              loadDataList();
              refreshDataOnChange();
            "
          >
            <el-option
              v-for="item in PlantList"
              :key="item.PlantCode"
              :label="item.PlantName"
              :value="item.PlantCode"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="block-top-line"></div>

      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-mid" style="">
            <div
              v-if="activeCategory == 'pvf' && activeChartGroup == 'chart'"
              class="form-inline"
            >
              <el-button-group>
                <el-button
                  :type="activeColumnGroup == 'energy' ? 'primary' : 'success'"
                  plain
                  :disabled="activeColumnGroup == 'energy'"
                  @click="onColumnGroupChanged('energy')"
                  >按电耗</el-button
                >
                <el-button
                  :type="activeColumnGroup == 'time' ? 'primary' : 'success'"
                  plain
                  :disabled="activeColumnGroup == 'time'"
                  @click="onColumnGroupChanged('time')"
                  >按时间</el-button
                >
              </el-button-group>
            </div>
            <div
              class="form-inline"
              style="padding-right: 50px; padding-left: 50px"
            >
              <el-button-group>
                <el-button
                  :type="activeChartGroup == 'chart' ? 'primary' : 'success'"
                  plain
                  :disabled="activeChartGroup == 'chart'"
                  icon="el-icon-s-data"
                  @click="onChartGroupChanged('chart')"
                ></el-button>
                <el-button
                  :type="activeChartGroup == 'table' ? 'primary' : 'success'"
                  plain
                  :disabled="activeChartGroup == 'table'"
                  icon="el-icon-s-grid"
                  @click="onChartGroupChanged('table')"
                ></el-button>
              </el-button-group>
            </div>
            <div
              v-if="activeChartGroup == 'table' || activeChartGroup == 'detail'"
              class="form-inline"
            >
              <el-button-group>
                <el-button
                  plain
                  icon="el-icon-document"
                  @click="handleDownload()"
                  >导出</el-button
                >
              </el-button-group>
            </div>
            <div
              class="form-inline"
              style="padding-right: 50px; padding-left: 50px"
            >
              <el-date-picker
                v-model="selectedDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
            <div
              style="padding-right: 50px; padding-left: 50px"
              class="form-inline"
            >
              <el-select
                v-model="selectedFilterOrder"
                placeholder="从大到小"
                style="width: 130px"
              >
                <el-option
                  v-for="item in FilterOrder"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-model="FilterNumber"
                style="width: 80px"
                placeholder="前N"
              ></el-input>
              <el-button type="success" plain @click="refreshDataOnChange()"
                >查询</el-button
              >
            </div>
          </div>
          <div style="height: 100%">
            <div
              v-show="activeCategory == 'kpi' && activeChartGroup == 'table'"
              class="block-top-content"
              id="kpi_table"
            >
              <el-table
                :data="tableData_kpi"
                style="width: 100%"
                height="95%"
                :default-sort="{ prop: 'count', order: 'descending' }"
              >
                <el-table-column
                  prop="PlantCode"
                  label="工厂"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="ElectricityValue"
                  label="能耗(KWH)"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="AirValue"
                  label="产气量"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="KPI"
                  label="KPI"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="SaveTime"
                  label="时间"
                  sortable
                ></el-table-column>
              </el-table>
            </div>
            <div
              v-show="activeCategory == 'kpi' && activeChartGroup == 'detail'"
              class="block-top-content"
              id="kpi_detail"
            >
              <el-table
                :data="tableData_kpi_detail"
                style="width: 100%"
                height="95%"
                :default-sort="{ prop: 'count', order: 'descending' }"
              >
                <el-table-column
                  prop="PlantName"
                  label="工厂"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="ManufacturerType"
                  label="品牌"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="TonnageType"
                  label="吨位"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="EquipmentNo"
                  label="注塑机代码"
                  sortable
                  width="130"
                  hidden="true"
                  :filters="CurrentEquipmentList"
                  :filter-method="filterEquipmentNo"
                  filter-placement="bottom-end"
                ></el-table-column>
                <el-table-column
                  prop="EquipmentName"
                  label="注塑机名称"
                  sortable
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="Day"
                  label="日期"
                  sortable
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueRunning"
                  label="生产电耗(kWh)"
                  sortable
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueDay"
                  label="总电耗(kWh)"
                  sortable
                  width="130"
                ></el-table-column>
                <el-table-column
                  prop="WorkTimeDay"
                  label="生产时间(H)"
                  sortable
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueByMinutes"
                  label="分钟单耗"
                  sortable
                  width="130"
                ></el-table-column>
                <el-table-column
                  prop="ProductMold"
                  label="开模数"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueByMold"
                  label="模单耗"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="ProductWeight"
                  label="公斤数"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueByKG"
                  label="公斤单耗"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="ProductQty"
                  label="件数"
                  sortable
                ></el-table-column>
              </el-table>
            </div>
            <div
              v-show="activeCategory == 'rate' && activeChartGroup == 'table'"
              class="block-top-content"
              id="rate_table"
            >
              <el-table
                :data="tableData_rate"
                style="width: 100%"
                height="95%"
                :default-sort="{ prop: 'count', order: 'descending' }"
              >
                <el-table-column
                  prop="PlantName"
                  label="工厂"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="ManufacturerType"
                  label="品牌"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="TonnageType"
                  label="吨位"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="EquipmentNo"
                  label="注塑机代码"
                  sortable
                  width="130"
                  hidden="true"
                  :filters="CurrentEquipmentList"
                  :filter-method="filterEquipmentNo"
                  filter-placement="bottom-end"
                ></el-table-column>
                <el-table-column
                  prop="EquipmentName"
                  label="注塑机名称"
                  sortable
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueRunning"
                  label="生产电耗(kWh)"
                  sortable
                  width="140"
                ></el-table-column>
                <el-table-column
                  prop="EnergyValueDay"
                  label="总电耗(kWh)"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="EnergyRate"
                  label="能耗利用率(%)"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="WorkTimeRunning"
                  label="运行时间(H)"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="TotalCalendarHours"
                  label="日历时间(H)"
                  sortable
                ></el-table-column>
                <el-table-column
                  prop="TimeRate"
                  label="时间利用率(%)"
                  sortable
                ></el-table-column>
              </el-table>
            </div>
            <div
              v-if="activeCategory == 'kpi' && activeChartGroup == 'chart'"
              class="block-top-content"
            >
              <div style="width: 40%; height: 100%">
                <kpi1 ref="kpi1Component"></kpi1>
              </div>
              <div style="width: 60%; height: 100%">
                <div style="width: 100%; height: 100%">
                  <kpi2 ref="kpi2Component"></kpi2>
                </div>
                <!-- <div style="width: 100%; height: 50%">
                  <kpi3 ref="kpi3Component"></kpi3>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from "../TopMenu/topHeader.vue";
import kpi1 from "./kpi1.vue";
import kpi2 from "./kpi2.vue";
// import kpi3 from "./kpi3.vue";
import request from "@/utils/request";
import { AREA_LIST, BU_LIST } from "../mainPage/area_bu";

export default {
  name: "InjMold",
  components: {
    topHeader,
    kpi1,
    kpi2,
  },
  data() {
    return {
      PageTitle: "空压机对标",
      AreaList: AREA_LIST,
      BUList: BU_LIST,
      selectedArea: "GLOBAL",
      selectedBU: "",
      selectedPlant: "",
      selectedBranch: "",
      selectedTon: "",
      selectedEquipment: "",
      selectedDateRange: "",
      selectedFilterBy: "",
      activeChartGroup: "chart",
      activeCategory: "kpi",
      activeColumnGroup: "energy",
      selectedFilterOrder: "desc",
      FilterNumber: "10",
      FilterList: [],
      PlantList: [],
      BranchList: [],
      TonList: [],
      EquipmentList: [],
      CurrentEquipmentList: [],
      tableData_kpi: [],
      tableData_kpi_detail: [],
      tableData_rate: [],
      tableData_rate_detail: [],
      tableData_pvf: [],
      tableData_pvf_detail: [],
      FilterListCategory: {
        kpi: [
          { value: "kpi_minute", label: "分钟单耗" },
          { value: "kpi_kg", label: "公斤单耗" },
          { value: "kpi_mold", label: "模单耗" },
        ],
        rate: [
          { value: "rate_cost", label: "能源利用率" },
          { value: "rate_time", label: "时间利用率" },
        ],
        pvf: [
          { value: "pvf_peak", label: "峰时占比" },
          { value: "pvf_flat", label: "平时占比" },
          { value: "pvf_valley", label: "谷时占比" },
          { value: "pvf_avg_cost", label: "均价" },
        ],
      },
      FilterOrder: [
        { value: "desc", label: "从大到小" },
        { value: "asc", label: "从小到大" },
      ],
    };
  },
  mounted() {
    const { loadDataList, refreshDataOnChange, refreshPlantList } = this;
    var day1 = new Date();
    day1.setDate(1);
    var day2 = new Date();
    //day2.setTime(day2.getTime()-24*60*60*1000)
    this.selectedDateRange = [day1, day2];

    this.selectedFilterBy = this.FilterListCategory[
      this.activeCategory
    ][0].value;
    loadDataList();

    refreshDataOnChange();
  },
  methods: {
    loadDataList() {
      const { formatDate } = this;

      let selBu = "";
      if (this.selectedBU !== undefined && this.selectedBU !== "") {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU;
      }
      let selPlant = "";
      if (this.selectedPlant !== undefined && this.selectedPlant !== "") {
        selPlant = this.selectedPlant.join();
      }
      let selEquip = "";
      if (
        this.selectedEquipment !== undefined &&
        this.selectedEquipment !== ""
      ) {
        selEquip = this.selectedEquipment.join();
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: selBu,
        QueryPlantCode: selPlant,
        QueryManufacturerType: this.selectedBranch,
        QueryTonnageType: this.selectedTon,
        QueryEquipment: selEquip,
        QueryFilterBy: this.selectedFilterBy,
        QueryOrderAsc: this.selectedFilterOrder,
        QueryFilterOrder: this.FilterNumber,
        QueryDataCategory: this.activeCategory,
        QueryDetailData: this.activeChartGroup == "detail" ? "Y" : "",
      };
      if (
        this.selectedDateRange != undefined &&
        this.selectedDateRange.length > 1
      ) {
        queryArgs.QueryStartMonth = formatDate(this.selectedDateRange[0]);
        queryArgs.QueryEndMonth = formatDate(this.selectedDateRange[1]);
      }

      request({
        url: "Kanban/Molding_DataList",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        this.BranchList = res.data.Data.ManufacturerType;
        this.BranchList.push({ CategoryName: "品牌", CategoryCode: "" });
        this.TonList = res.data.Data.TonnageType;
        this.TonList.push({ CategoryName: "吨位", CategoryCode: "" });
      });
    },
    refreshPlantList() {
      const { loadDataList, refreshDataOnChange } = this;

      let selBu = "";
      if (this.selectedBU !== undefined && this.selectedBU !== "") {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU;
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: selBu,
        QueryFilterBy: "IsUpload",
      };
      request({
        url: "Kanban/PlantList",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        this.PlantList = res.data.Data.PlantList;
      });
      loadDataList();
    },
    onChartGroupChanged(chartType) {
      const { refreshDataOnChange } = this;

      this.activeChartGroup = chartType;

      refreshDataOnChange();
    },
    onCategoryChanged(category) {
      const { refreshDataOnChange } = this;

      this.activeCategory = category;
      this.selectedFilterBy = this.FilterListCategory[
        this.activeCategory
      ][0].value;
      refreshDataOnChange();
    },
    onColumnGroupChanged(group) {
      const { refreshDataOnChange } = this;

      this.activeColumnGroup = group;

      refreshDataOnChange();
    },
    refreshDataOnChange() {
      const { formatDate } = this;

      let selBu = "";
      if (this.selectedBU !== undefined && this.selectedBU !== "") {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU;
      }
      let selPlant = "";
      if (this.selectedPlant !== undefined && this.selectedPlant !== "") {
        selPlant = this.selectedPlant.join();
      }
      let selEquip = "";
      let oneEquipment = "";
      if (
        this.selectedEquipment !== undefined &&
        this.selectedEquipment !== ""
      ) {
        selEquip = this.selectedEquipment.join();
        oneEquipment = this.selectedEquipment.length == 1 ? "Y" : "";
      }
      const queryArgs = {
        QueryAreaName: this.selectedArea,
        QueryBU: selBu,
        QueryPlantCode: selPlant,
        QueryManufacturerType: this.selectedBranch,
        QueryTonnageType: this.selectedTon,
        QueryEquipment: selEquip,
        QueryFilterBy: this.selectedFilterBy,
        QueryOrderAsc: this.selectedFilterOrder,
        QueryFilterOrder: this.FilterNumber,
        QueryDataCategory: this.activeCategory,
        QueryColumnGroup: this.activeColumnGroup,
        QueryDetailData: this.activeChartGroup == "detail" ? "Y" : "",
        QueryGroupBy: oneEquipment == "Y" ? "Day" : "",
      };
      if (
        this.selectedDateRange != undefined &&
        this.selectedDateRange.length > 1
      ) {
        queryArgs.QueryStartMonth = formatDate(this.selectedDateRange[0]);
        queryArgs.QueryEndMonth = formatDate(this.selectedDateRange[1]);
      }
      request({
        url: "Kanban/GetAirCompressorData",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        console.log("A1", res.data);
        // KPI
        var vData = res.data;
        this.tableData_kpi = vData.ar3;
        this.$refs.kpi1Component.refreshChart(vData.ar1, queryArgs);
        this.$refs.kpi2Component.refreshChart(vData.ar2);
     //   this.$refs.kpi3Component.refreshChart(vData.ar4);
      });
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      if (m < 10) m = "0" + m;
      var d = date.getDate();
      if (d < 10) d = "0" + d;
      var s = y + "-" + m + "-" + d;
      return s;
    },
    filterEquipmentNo(value, row) {
      return row.EquipmentNo === value;
    },
    changeSelectComponent(title, id) {
      var text = "All";
      var val = this[id];
      if (val.length == 1) {
        text = val[0];
      } else if (val.length > 1) {
        text = title + ": " + "Selected " + val.length;
      }
      document.querySelector("#" + id).value = text;
    },
    handleDownload() {
      const { formatDate } = this;
      var tableId = this.activeCategory + "_" + this.activeChartGroup;

      var opts = {
        skipRow: 1,
        staticContent: [
          { c: 0, r: 0, content: "BU:" + this.selectedBU },
          { c: 1, r: 0, content: "工厂:" + this.selectedPlant },
          { c: 2, r: 0, content: "品牌:" + this.selectedBranch },
          { c: 3, r: 0, content: "吨位:" + this.selectedTon },
          {
            c: 4,
            r: 0,
            content: "起始日期:" + formatDate(this.selectedDateRange[0]),
          },
          {
            c: 5,
            r: 0,
            content: "截至日期:" + formatDate(this.selectedDateRange[1]),
          },
        ],
      };
      import("../Export2Excel/Export2Excel").then((excel) => {
        excel.export_table_to_excel({
          id: tableId,
          opts: opts,
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
  },
  created() {},
};
</script>

<style lang="less">
#InjMold-view {
  width: 100%;
  height: 100%;
  background-color: #1b2445;
  color: #fff;
  #dv-full-screen-container {
    background-image: url("");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1b2445;
  }
  .block-top-line {
    background-color: #313c5e;
    width: 100%;
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 100%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .pingpu {
    display: flex;
  }
  .dddss {
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-button-field {
    background-color: #1b2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .el-select .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
    font-size: 22px;
  }
  .el-date-editor el-range-editor el-input__inner el-date-editor--daterange {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
  }
  .el-range-input {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    font-size: 22px;
  }
  .el-tag.el-tag--info {
    display: none !important;
  }
}
</style>
